module.exports = __webpack_public_path__ + "media/images/app-store-logo-ea3e4f566337ced24ce08620bb2f58af.png";